import { useContext } from 'react';

import { InputPasswordContext } from '../contexts/InputPasswordContext';
import { IInputPasswordContext } from '../types';

export const useInputPassword = (): IInputPasswordContext => {
  return useContext(InputPasswordContext);
};
